{
  "navbar": {
    "logout": "로그아웃"
  }
}
